import { USER_MENU } from "./constants";

export const getMenu = (menu_type,user_tp) => {

    const menu = USER_MENU[user_tp][menu_type];

    const main = menu.filter((item,index)=>item.TYPE==='MAIN');
    const sub = menu.filter((item,index)=>item.TYPE==='SUB');

    return {main,sub}

}

export const formatBizNo = (param) => {
    if(param){
        if(param.length > 3 && param.length < 6){
            return param.substring(0,3)+'-'+param.substring(3,param.length)
        }else if(param.length > 5){
            return param.substring(0,3)+'-'+param.substring(3,5)+'-'+param.substring(5,param.length)
        }else{
            return param
        }

    }
}

export const zeroPad = (param) => {
    let retVal = param+''
    if(retVal.length<5){
        while(retVal.length < 5){
            retVal = '0'+''+retVal
        }
    }
    return retVal
}

export const secCal = (unit, sec) => {
    switch(unit){
        case 'M' :
            return sec/60;
        case 'S' :
            return sec;
        default :
            return sec;
    }
}